import React from 'react';
import PropTypes from 'prop-types';
import { TableBody } from '@mui/material';
import { sequence, get } from '@totalsoft/change-tracking-react';
import FinancialProductRulesEditDetailsCommissionsTableRow from './FinancialProductRulesEditDetailsCommissionsTableRow';
import { useTranslation } from 'react-i18next';
import { isValid } from '@totalsoft/pure-validations-react';
import { Typography } from '@totalsoft/rocket-ui';
import { StyledTableRow } from 'components/common/Styles';

const FinancialProductRulesEditDetailsCommissionsTableBody = ({
  canWrite,
  commissionList,
  onDelete,
  financialProductRuleCommissionValidation
}) => {
  const [t] = useTranslation();

  return (
    <TableBody>
      {!isValid(financialProductRuleCommissionValidation) &&
        !sequence(commissionList)?.find((_, index) => {
          return !isValid(financialProductRuleCommissionValidation[index]);
        }) && (
          <StyledTableRow>
            <Typography color='error'>{t('FinancialProduct.Details.Rules.Details.Commissions.ValidationList')}</Typography>
          </StyledTableRow>
        )}
      {sequence(commissionList)?.map((commission, index) => {
        return (
          <FinancialProductRulesEditDetailsCommissionsTableRow
            canWrite={canWrite}
            key={`${index}_${commission.financialProductRuleCommissionId |> get}`}
            commissionLens={commission}
            onDelete={onDelete}
          />
        );
      })}
    </TableBody>
  );
};

FinancialProductRulesEditDetailsCommissionsTableBody.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  commissionList: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
  financialProductRuleCommissionValidation: PropTypes.object.isRequired
};

export default FinancialProductRulesEditDetailsCommissionsTableBody;
